import React from 'react'
import cn from 'classnames'

import { Checkbox } from '@components/Checkbox'
import { ConsentProps } from './interface'

export function Consent({
  latestConsent,
  className,
  checked,
  openTermsOfServiceModal,
}: ConsentProps) {
  return (
    <div
      className={cn(
        'grid grid-cols-1 gap-y-[10px] border-gray-3 dark:border-purple border-t-[1px] pt-[30px] mobile:pt-[20px]',
        className
      )}
    >
      <Checkbox
        checked={checked}
        className='w-full text-secondary text-[14px] font-light mobile:items-start'
        label={
          <div className='flex mobile:flex-col dark:text-dark-10'>
            ข้าพเจ้าได้อ่านและยอมรับ&nbsp;
            <div className='text-primary underline cursor-pointer'>
              {latestConsent.name}
            </div>
          </div>
        }
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          e.preventDefault()
          openTermsOfServiceModal(latestConsent)
        }}
      />
    </div>
  )
}
